import { render, staticRenderFns } from "./MultipleChoiceImagePublicDisplayItem.vue?vue&type=template&id=c660cb30&scoped=true"
import script from "./MultipleChoiceImagePublicDisplayItem.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceImagePublicDisplayItem.vue?vue&type=script&lang=js"
import style0 from "./MultipleChoiceImagePublicDisplayItem.vue?vue&type=style&index=0&id=c660cb30&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c660cb30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c660cb30')) {
      api.createRecord('c660cb30', component.options)
    } else {
      api.reload('c660cb30', component.options)
    }
    module.hot.accept("./MultipleChoiceImagePublicDisplayItem.vue?vue&type=template&id=c660cb30&scoped=true", function () {
      api.rerender('c660cb30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PublicDisplay/MultipleChoiceImagePublicDisplayItem.vue"
export default component.exports